import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { transformToNestObject, appendErrors } from 'react-hook-form';

var parseErrorSchema = function parseErrorSchema(error, validateAllFieldCriteria) {
  return Array.isArray(error.inner) && error.inner.length ? error.inner.reduce(function (previous, _ref) {
    var path = _ref.path,
        message = _ref.message,
        type = _ref.type;
    var previousTypes = previous[path] && previous[path].types || {};
    return Object.assign(Object.assign({}, previous), path ? _defineProperty({}, path, Object.assign(Object.assign({}, previous[path] || {
      message: message,
      type: type
    }), validateAllFieldCriteria ? {
      types: Object.assign(Object.assign({}, previousTypes), _defineProperty({}, type, previousTypes[type] ? [].concat(_toConsumableArray([].concat(previousTypes[type])), [message]) : message))
    } : {})) : {});
  }, {}) : _defineProperty({}, error.path, {
    message: error.message,
    type: error.type
  });
};

var yupResolver = function yupResolver(schema) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    abortEarly: false
  };
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, context) {
      var validateAllFieldCriteria,
          parsedErrors,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validateAllFieldCriteria = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              _context.prev = 1;

              if (options.context && process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead");
              }

              _context.next = 5;
              return schema.validate(values, Object.assign(Object.assign({}, options), {
                context: context
              }));

            case 5:
              _context.t0 = _context.sent;
              _context.t1 = {};
              return _context.abrupt("return", {
                values: _context.t0,
                errors: _context.t1
              });

            case 10:
              _context.prev = 10;
              _context.t2 = _context["catch"](1);
              parsedErrors = parseErrorSchema(_context.t2, validateAllFieldCriteria);
              return _context.abrupt("return", {
                values: {},
                errors: validateAllFieldCriteria ? parsedErrors : transformToNestObject(parsedErrors)
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var convertArrayToPathName = function convertArrayToPathName(paths) {
  return paths.reduce(function (previous, path, index) {
    return "".concat(previous).concat(typeof path === 'string' ? "".concat(index > 0 ? '.' : '').concat(path) : "[".concat(path, "]"));
  }, '').toString();
};

var parseErrorSchema$1 = function parseErrorSchema$1(error, validateAllFieldCriteria) {
  return Array.isArray(error.failures) ? error.failures.reduce(function (previous, _ref5) {
    var path = _ref5.path,
        _ref5$message = _ref5.message,
        message = _ref5$message === void 0 ? '' : _ref5$message,
        type = _ref5.type;
    var currentPath = convertArrayToPathName(path);
    return Object.assign(Object.assign({}, previous), path ? previous[currentPath] && validateAllFieldCriteria ? _defineProperty({}, currentPath, appendErrors(currentPath, validateAllFieldCriteria, previous, type || '', message)) : _defineProperty({}, currentPath, previous[currentPath] || Object.assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: _defineProperty({}, type || '', message || true)
    } : {})) : {});
  }, {}) : [];
};

var superstructResolver = function superstructResolver(schema) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values, _) {
      var validateAllFieldCriteria,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              validateAllFieldCriteria = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              _context2.prev = 1;
              return _context2.abrupt("return", {
                values: schema(values),
                errors: {}
              });

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](1);
              return _context2.abrupt("return", {
                values: {},
                errors: transformToNestObject(parseErrorSchema$1(_context2.t0, validateAllFieldCriteria))
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 5]]);
    }));

    return function (_x3, _x4) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var parseErrorSchema$2 = function parseErrorSchema$2(error, validateAllFieldCriteria) {
  return Array.isArray(error.details) ? error.details.reduce(function (previous, _ref9) {
    var path = _ref9.path,
        _ref9$message = _ref9.message,
        message = _ref9$message === void 0 ? '' : _ref9$message,
        type = _ref9.type;
    var currentPath = convertArrayToPathName(path);
    return Object.assign(Object.assign({}, previous), path ? previous[currentPath] && validateAllFieldCriteria ? _defineProperty({}, currentPath, appendErrors(currentPath, validateAllFieldCriteria, previous, type, message)) : _defineProperty({}, currentPath, previous[currentPath] || Object.assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: _defineProperty({}, type, message || true)
    } : {})) : {});
  }, {}) : [];
};

var joiResolver = function joiResolver(schema) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    abortEarly: false
  };
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(values, _) {
      var validateAllFieldCriteria,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              validateAllFieldCriteria = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              _context3.prev = 1;
              _context3.next = 4;
              return schema.validateAsync(values, Object.assign({}, options));

            case 4:
              _context3.t0 = _context3.sent;
              _context3.t1 = {};
              return _context3.abrupt("return", {
                values: _context3.t0,
                errors: _context3.t1
              });

            case 9:
              _context3.prev = 9;
              _context3.t2 = _context3["catch"](1);
              return _context3.abrupt("return", {
                values: {},
                errors: transformToNestObject(parseErrorSchema$2(_context3.t2, validateAllFieldCriteria))
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 9]]);
    }));

    return function (_x5, _x6) {
      return _ref12.apply(this, arguments);
    };
  }();
};

export { joiResolver, superstructResolver, yupResolver };